import { toast } from "react-toastify";
import { AUTHENTICATION } from "config/apiEndPoint";
import { POST } from "config/api.config";

export const startSessionBreak = async () => {
  try {
    const response = await POST(AUTHENTICATION.SESSION_BREAK_START, {});
    return response;
  } catch (error) {
    toast.error(error?.message || "Unable to start break");
    return null;
  }
};

export const endSessionBreak = async () => {
  try {
    const response = await POST(AUTHENTICATION.SESSION_BREAK_END, {});
    return response;
  } catch (error) {
    toast.error(error?.message || "Unable to end break");
    return null;
  }
};
